var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { styled } from "../styling";
const Container = styled.div `
  display: flex;
  flex-direction: column;
`;
export const AccordionContext = React.createContext({});
export const Accordion = (_a) => {
    var { children, activeIndex, onChange } = _a, rest = __rest(_a, ["children", "activeIndex", "onChange"]);
    return (React.createElement(AccordionContext.Provider, { value: { activeIndex, setActiveIndex: onChange } },
        React.createElement(Container, Object.assign({}, rest), children)));
};
//# sourceMappingURL=Accordion.js.map